// Gives every page its own browser tab title (also what Google shows for that page). The front page keeps the
// title from public/index.html, which is written for Google searches.
const SITE = "Chess Corner";
const FRONT_PAGE_TITLE = "Chess Corner · Play chess online with Rook, your AI coach";

const TITLES = [
    ["/computer", "Play the computer"],
    ["/play", "Game"],
    ["/analysis", "Analysis"],
    ["/leaderboards", "Leaderboards"],
    ["/social", "Social"],
    ["/my-profile", "My profile"],
    ["/messages", "Messages"],
    ["/credits", "Credits"],
    ["/feedback", "Feedback"]
];

export const titleFor = (pathname, search = "") => {
    if (pathname === "/") return FRONT_PAGE_TITLE;
    if (pathname.startsWith("/profile")) {
        const username = new URLSearchParams(search).get("username");
        return username ? `${username} · ${SITE}` : SITE;
    }
    const match = TITLES.find(([path]) => pathname === path || pathname.startsWith(path + "/"));
    return match ? `${match[1]} · ${SITE}` : `Page not found · ${SITE}`;
};
